import { render, staticRenderFns } from "./ICD10AutoCompleteSlot.vue?vue&type=template&id=2fbcd766&scoped=true&"
import script from "./ICD10AutoCompleteSlot.vue?vue&type=script&lang=js&"
export * from "./ICD10AutoCompleteSlot.vue?vue&type=script&lang=js&"
import style0 from "./ICD10AutoCompleteSlot.vue?vue&type=style&index=0&id=2fbcd766&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbcd766",
  null
  
)

export default component.exports